import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex: 1;\n  padding-bottom: ", ";\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  color: ", ";\n  position: relative;\n  text-align: left;\n  > * {\n    display: block;\n    margin: 0px !important;\n    + a {\n      margin-top: 4px !important;\n    }\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import cuid from 'cuid';
import { calculateRem } from '@uie/javascript-style-helpers';
import RadioButtonLabel from './RadioButtonLabel';
import DefaultIcon from './RadioButtonIcon';
import { colors, calculateSpacing } from '@vds-core/theme';
import { BodyConfig, TypographyConfig } from '@vds-core/typography';
import { withVDSManager } from '@vds-core/utilities';
var propTypes = {
  /**
   * If provided, the Radio will be rendered with children.
   */
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.array, PropTypes.node]),

  /**
   * If provided, the Radio will be rendered in the Disabled State.
   */
  disabled: PropTypes.bool,

  /**
   * Name of RadioButton.
   */
  name: PropTypes.string.isRequired,

  /**
   * Callback function that returns the value of the radio when clicked.
   */
  onChange: PropTypes.func,

  /**
   * Value of RadioButton.
   */
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * If provided, the Radio will be rendered in the Selected State.
   */
  selected: PropTypes.bool,

  /**
   * @ignore If passed, the Body component from VDS will render
   */
  Body: PropTypes.func,

  /**
   * @ignore
   */
  ariaLabel: PropTypes.string,

  /**
   * If provided, the Radio will be rendered in the Error State.
   */
  error: PropTypes.bool,

  /**
   * @deprecated
   * If provided, the Radio will be rendered in the Selected State.
   */
  checked: PropTypes.bool,

  /**
   * @ignore
   * If provided a string of a proper multiplier constant in calculate spacing, a bottom of a margin 4 times the input will render.
   */
  marginBottom: PropTypes.string,

  /**
   * @ignore
   * If provided, an object containing color values in hex will be returned
   */
  colorConfig: PropTypes.object,

  /**
   * @ignore
   * If provided, an object containing font-family, font-size, and line-height will be returned.
   */
  bodyConfig: PropTypes.object,

  /**
   * @ignore
   * If provided, a new RadioButtonIcon will be returned.
   */
  RadioButtonIcon: PropTypes.func,

  /**
   * @ignore
   * Typescale of text within RadioButton.
   */
  typescale: PropTypes.string,

  /**
   * @ignore
   * If provided, a hover state that thickens the border of the RadioButtonIcon will exist.
   */
  hoverState: PropTypes.bool,

  /**
   * @ignore
   * If provided, a dashed focus state will render RadioButtonIcon will exist.
   */
  focusState: PropTypes.bool,

  /**
   * @ignore
   * If provided, the RadioButton will break into a new line at the given string value width.
   */
  maxLabelWidth: PropTypes.string,

  /**
   * @ignore
   * If provided, padding surrounding the RadioButton will render.
   */
  padding: PropTypes.string,

  /**
   * Allows a string to be provided for analytics.
   */
  'data-analyticstrack': PropTypes.string,

  /**
   * Allows a string to be provided for analytics.
   */
  'data-track': PropTypes.string,

  /**
   * Allows a string to be provided for click stream.
   */
  'data-clickstream': PropTypes.string,

  /**
   * Allows a unique ID to be passed to the component.
   */
  id: PropTypes.string,

  /**
   * Allows a unique ID to be passed to the input element.
   */
  inputId: PropTypes.string
};
var defaultProps = {
  value: '',
  selected: undefined,
  children: '',
  disabled: false,
  error: false,
  onChange: function onChange() {},
  className: null,
  marginBottom: null,
  bodyConfig: BodyConfig,
  colorConfig: colors,
  name: '',
  RadioButtonIcon: DefaultIcon,
  typescale: TypographyConfig.getTypescale(),
  hoverState: false,
  focusState: false,
  maxLabelWidth: undefined,
  padding: calculateRem(2, 0, 24, 8)
};
var ChildWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "ChildWrapper",
  componentId: "sc-186ek2u-0"
})(_templateObject(), colors.black);
var LabelWrapper = /*#__PURE__*/styled.span.withConfig({
  displayName: "LabelWrapper",
  componentId: "sc-186ek2u-1"
})(_templateObject2(), calculateSpacing('1X'));

var RadioButton = /*#__PURE__*/function (_React$Component) {
  _inherits(RadioButton, _React$Component);

  var _super = _createSuper(RadioButton);

  function RadioButton() {
    var _this;

    _classCallCheck(this, RadioButton);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      selected: _this.props.selected || _this.props.checked || false
    });

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      _this.isControlled = _this.props.checked !== undefined || _this.props.selected !== undefined;
    });

    _defineProperty(_assertThisInitialized(_this), "componentDidUpdate", function (prevProps, prevState) {
      if (prevProps && prevProps.selected !== _this.props.selected) {
        _this.setState(function (prevProps) {
          return {
            selected: !prevProps.selected
          };
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleCheck", function (e) {
      if (_this.isControlled) {
        _this.props.onChange(e);
      } else {
        _this.setState(function (prevState) {
          return {
            selected: !prevState.selected
          };
        });
      }

      if (e.type === 'click' && e.clientX !== 0 && e.clientY !== 0) {
        e.currentTarget.blur();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "blurOnClick", function (e) {
      if (e.type === 'click' && e.clientX !== 0 && e.clientY !== 0) {
        e.currentTarget.blur();
      }
    });

    return _this;
  }

  _createClass(RadioButton, [{
    key: "render",
    value: function render() {
      this.id = cuid();
      var _this$props = this.props,
          checkedProp = _this$props.checked,
          selectedProp = _this$props.selected,
          children = _this$props.children,
          label = _this$props.label,
          Body = _this$props.Body,
          className = _this$props.className,
          disabled = _this$props.disabled,
          error = _this$props.error,
          name = _this$props.name,
          value = _this$props.value,
          ariaLabel = _this$props.ariaLabel,
          colorConfig = _this$props.colorConfig,
          bodyConfig = _this$props.bodyConfig,
          marginBottom = _this$props.marginBottom,
          RadioButtonIcon = _this$props.RadioButtonIcon,
          typescale = _this$props.typescale,
          hoverState = _this$props.hoverState,
          focusState = _this$props.focusState,
          maxLabelWidth = _this$props.maxLabelWidth,
          padding = _this$props.padding,
          id = _this$props.id,
          inputId = _this$props.inputId,
          analyticsTrack = _this$props['data-analyticstrack'],
          track = _this$props['data-track'],
          clickStream = _this$props['data-clickstream'];
      var selected = this.state.selected;
      var radioId = inputId ? inputId : cuid();
      return /*#__PURE__*/React.createElement(RadioButtonLabel, {
        id: id,
        className: className,
        disabled: disabled,
        error: error,
        name: name,
        bodyConfig: bodyConfig,
        colorConfig: colorConfig,
        marginBottom: marginBottom,
        selected: selected,
        typescale: typescale,
        hoverState: hoverState,
        focusState: focusState,
        maxLabelWidth: maxLabelWidth,
        padding: padding,
        htmlFor: radioId
      }, /*#__PURE__*/React.createElement("input", {
        checked: selected,
        disabled: disabled,
        id: radioId,
        name: name,
        onChange: this.handleCheck,
        onClick: this.blurOnClick,
        role: "radio",
        type: "radio",
        value: value,
        "data-analyticstrack": analyticsTrack,
        "data-track": track,
        "data-clickstream": clickStream
      }), /*#__PURE__*/React.createElement(RadioButtonIcon, {
        selected: selected,
        disabled: disabled,
        error: error,
        colorConfig: colorConfig
      }), /*#__PURE__*/React.createElement(ChildWrapper, null, label && Body && /*#__PURE__*/React.createElement(LabelWrapper, null, /*#__PURE__*/React.createElement(Body, {
        size: "large",
        bold: true,
        color: disabled ? colors.coolGray3 : colors.black
      }, label)), children));
    }
  }]);

  return RadioButton;
}(React.Component);

RadioButton.propTypes = propTypes;
RadioButton.defaultProps = defaultProps;
export default withVDSManager(RadioButton);